// Angular
import { Component, ComponentFactoryResolver, OnDestroy } from '@angular/core';
import { BroadcastService, ModalService, ModalSize } from '@cv-invision/core';
// AG-Grid
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { LenderService } from '../../service/lender.service';
import { CreateUpdateLenderComponent } from '../create-update-lender/create-update-lender.component';
import { DELETE_MAPPER_LENDER } from '../model/lender.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'cv-lender-custom-action',
	templateUrl: './custom-action-lender-cell.component.html',
	styleUrls: ['./custom-action-lender-cell.component.scss']
})
export class CustomActionLenderCellComponent implements ICellRendererAngularComp, OnDestroy {
	private atComponentDestroy: Subject<any> = new Subject<any>();
	public cellValue: any;

	constructor(
		private componentFactoryResolver: ComponentFactoryResolver,
		private modalService: ModalService,
		private lenderService: LenderService,
		private broadcastService: BroadcastService,
	) {}

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.data;
	}

	/**
	 * Edit Mapper Lender Configuration
	 */
	onEditMapperLender(): void {
		this.modalService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: CreateUpdateLenderComponent,
				data: {
					isEditing: true,
					lenderMapperData: this.cellValue
				},
				modalConfiguration: {
					title: 'Edit Mapper Lender Configuration',
					modalSize: ModalSize.XL
				}
			})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if (result.success) {
					this.lenderService.setReloadListConfirmation({
						reloadList: true
					});
				} else {
					// it failed :(
				}
			});
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}

	/**
	 * On Delete Mapper Button Click.
	 * @param $event
	 */
	onDeleteMapperLender(): void {
		this.modalService
			.customConfirm(
				'Delete Mapper Lender',
				'Do you want to delete this Mapper Lender ?',
				'icon-warning fas fa-exclamation-circle',
				'Delete Mapper Lender',
				'cv-btn-link-error'
			)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if (result.confirm === 'confirm') {
					this.deleteMapperLender();
				}
			});
	}

	/**
	 * Delete Mapper Lender.
	 * @private
	 */
	private deleteMapperLender(): void {
		this.broadcastService.broadcast({
			name: DELETE_MAPPER_LENDER,
			event: this.cellValue
		});
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
